import React, { memo } from 'react';
import { PropTypes } from 'prop-types';
import { useGetDocURLById } from 'utils/hooks';

import { Loader } from 'components';
import { Box } from '@mui/material';

const CompanyLogo = memo(props => {
    const { id, url = '', ...rest } = props;
    const { src, loading } = useGetDocURLById(id, url);

    if (!id) return null;

    return (
        <Loader loading={loading} size={20} marginTop={0}>
            <Box id={id} component="img" alt="" src={src} {...rest} />
        </Loader>
    );
});

CompanyLogo.propTypes = {
    id: PropTypes.number,
    url: PropTypes.string,
};

export default CompanyLogo;
